import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LogoIntro from "../components/LogoIntro"; // Assuming LogoIntro is a separate component

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showLogoIntro, setShowLogoIntro] = useState(false);
    const [result, setResult] = useState(null);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const result = await login(email, password);

            if (result.success) {
                setResult(result);
                setShowLogoIntro(true);
            } else {
                setError(result.error);
            }
        } catch (err) {
            setError("Napaka pri prijavi");
        } finally {
            setIsLoading(false);
        }
    };

    const handleLogoAnimationComplete = () => {
        switch (result.user?.role) {
            case "owner":
            case "manager":
                navigate("/pregled");
                break;
            case "agent":
                navigate("/agent");
                break;
            case "marketing":
                navigate("/marketing");
                break;
            case "dcs":
                navigate("/dcs");
                break;
            case "admin":
                navigate("/profile");
                break;
            default:
                navigate("/");
        }
    };

    return (
        <>
            {showLogoIntro ? (
                <LogoIntro
                    userName={result.user?.name}
                    onComplete={handleLogoAnimationComplete}
                />
            ) : (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f3f4f6",
                        padding: "1rem",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "400px",
                            backgroundColor: "white",
                            padding: "2rem",
                            borderRadius: "0.5rem",
                            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h1
                            style={{
                                fontSize: "1.875rem",
                                fontWeight: "bold",
                                textAlign: "center",
                                marginBottom: "1rem",
                            }}
                        >
                            STOJALITICS
                        </h1>

                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: "1rem" }}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email"
                                    style={{
                                        width: "100%",
                                        padding: "0.5rem",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "0.375rem",
                                        marginBottom: "1rem",
                                    }}
                                />

                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    placeholder="Password"
                                    style={{
                                        width: "100%",
                                        padding: "0.5rem",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "0.375rem",
                                    }}
                                />
                            </div>

                            {error && (
                                <div
                                    style={{
                                        backgroundColor: "#fee2e2",
                                        color: "#991b1b",
                                        padding: "0.5rem",
                                        borderRadius: "0.375rem",
                                        marginBottom: "1rem",
                                    }}
                                >
                                    {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={isLoading}
                                style={{
                                    width: "100%",
                                    backgroundColor: "#d31245",
                                    color: "white",
                                    padding: "0.5rem",
                                    borderRadius: "0.375rem",
                                    fontWeight: "500",
                                    cursor: isLoading
                                        ? "not-allowed"
                                        : "pointer",
                                    opacity: isLoading ? "0.7" : "1",
                                }}
                            >
                                {isLoading ? "Prijavljanje..." : "Prijava"}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
